<template>
  <v-card class="mb-25 pingo-card">
    <div class="v-card-header border-bottom">
      <h5 class="mb-0">Configurações</h5>
    </div>

    <!-- Navigate -->
    <ul class="ps-0 mt-0">
      <li>
        <router-link to="/configuracoes/conta"> Conta </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/enderecos"> Endereços </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/politica-de-privacidade">
          Política de Privacidade
        </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/termos-e-condicoes">
          Termos e Condições
        </router-link>
      </li>
    </ul>

    <!-- Form -->
    <form>
      <div class="d-flex justify-space-between">
        <div>
          <h5 class="fw-semibold mb-8">Endereços</h5>
          <p>Gerencie seus endereços aqui.</p>
        </div>

        <!-- <v-btn
          to="/configuracoes/endereco/novo"
          class="text-none default-btn"
          variant="tonal"
        >
          <i class="ri-add-fill"></i>
          Novo endereço
        </v-btn> -->

        <router-link to="/configuracoes/endereco/novo">
          <button type="button" class="default-btn px-8">Novo endereço</button>
        </router-link>
      </div>

      <div class="column mt-20">
        <div
          v-if="isLoadingAdresses"
          class="d-flex flex-column justify-space-center align-items-center text-center w-100 py-15"
        >
          <v-progress-circular
            class="mb-8"
            color="primary"
            indeterminate
          ></v-progress-circular>

          <span class="gray-color fw-medium d-inline-block">Carregando...</span>
        </div>

        <v-row v-if="!isLoadingAdresses">
          <v-col
            v-for="(address, index) in addresses"
            v-bind:key="index"
            cols="12"
            lg="4"
            md="4"
            sm="6"
          >
            <v-card class="pingo-card address-card">
              <div class="v-card-header border-bottom">
                <div
                  class="d-flex justify-space-between align-items-center w-100"
                >
                  <h5 class="mb-0">Endereço #{{ index + 1 }}</h5>

                  <DeleteAddressModal :address-id="address.addressId" />
                </div>
              </div>

              <div class="box">
                <h5 class="fw-semibold mb-15">{{ user.name }}</h5>

                <ul class="list ps-0 mb-0 mt-0">
                  <li class="gray-color position-relative">
                    <span class="fw-medium d-inline-block">Endereço:</span>
                    {{ address.street }} {{ address.number }},
                    {{ address.neighborhood }} - {{ address.city }},
                    {{ address.state }} {{ address.zipCode }},
                    {{ address.country }}
                  </li>

                  <li class="gray-color position-relative">
                    <span class="fw-medium d-inline-block">Complemento:</span>
                    {{ address.complement || "N/A" }}
                  </li>

                  <li class="gray-color position-relative">
                    <span class="fw-medium d-inline-block">
                      Endereço padrão:
                    </span>
                    {{ address.isDefault ? "Sim" : "Não" }}
                  </li>
                </ul>

                <v-divider class="my-4"></v-divider>

                <router-link
                  :to="`/configuracoes/endereco/editar/${address.addressId}`"
                >
                  <button type="button" class="default-btn w-100 px-8">
                    Alterar endereço
                  </button>
                </router-link>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </form>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, Ref, ref } from "vue";

import EventBus from "@/utils/eventBus";

import { useAuthStore } from "@/stores/auth.store";

import { useAddress } from "@/composables/useAddress";

import DeleteAddressModal from "@/components/Settings/Address/DeleteAddressModal.vue";

export default defineComponent({
  name: "SettingsAddressPage",
  components: { DeleteAddressModal },
  setup() {
    const authStore = useAuthStore();

    const { addresses, getAllAddresses } = useAddress();

    const user: Ref = ref(authStore.getUser);

    const isLoadingAdresses = ref(false);

    const fetchAddressesData = async () => {
      try {
        isLoadingAdresses.value = true;

        getAllAddresses(1, 25).then(() => {
          isLoadingAdresses.value = false;
        });
      } catch (error) {
        console.error("Erro ao buscar dados de endereços:", error);
      }
    };

    onMounted(async () => {
      await fetchAddressesData();

      // Listen for the address-update event
      EventBus.on("address-update", async () => {
        await fetchAddressesData();
      });
    });

    onUnmounted(() => {
      // Remove the event listener when the component is destroyed
      EventBus.off("address-update", fetchAddressesData);
    });

    return { isLoadingAdresses, user, addresses };
  },
});
</script>

<style lang="scss" scoped>
.box {
  h5 {
    font-size: 16px;
  }
  .list {
    display: flex;
    flex-direction: column;
    list-style-type: none;

    li {
      margin-bottom: 13px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.address-card {
  border: 1px solid #ccc !important;
}

.v-input__details {
  display: none !important;
}
button {
  &.success {
    background-color: var(--heraBlueColor);
    color: var(--whiteColor);
  }
  font: {
    weight: 600 !important;
    size: 14px !important;
  }
}
ul {
  list-style-type: none;
  margin-bottom: 15px;

  li {
    display: inline-block;
    margin: {
      right: 15px;
      bottom: 15px;
    }
    a {
      color: var(--paragraphColor);
      background-color: #f4f4f4;
      display: inline-block;
      border-radius: 5px;
      padding: 10px 25px;
      font: {
        size: var(--fontSize);
        weight: 600;
      }
      &:hover,
      &.active {
        background-color: var(--heraBlueColor);
        color: var(--whiteColor);
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

@media only screen and (max-width: 767px) {
  ul {
    li {
      a {
        font-size: 14px;
      }
    }
  }

  .box {
    h5 {
      font-size: 15px;
    }
  }
}
</style>
